
import {
  PackInfo,
  IFilterChannelOrLibInfo,
  IPriceOption
} from "../types";
import {
  RootState
} from "../../../stores/store";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface getStartedState {
  isShowSubscribeModal: boolean;
  packInfo: PackInfo;
  isShowFitlerPopUp: boolean;
  filterChannelOrLibInfo: IFilterChannelOrLibInfo;
  filterPlansInfo: any[];
  hideOtherPacks: boolean;
  packDetailInfoId: string;
  isShowPackInfoDetail: boolean;
  isTvBoxPage: boolean;
  isBoxPlan: boolean;
}

const initialState = {
  isShowSubscribeModal: false,
  packInfo: {
    optionsContext: '',
    PriceOptions: [] as Array<IPriceOption>,
    name: ''
  },
  isShowFitlerPopUp: false,
  filterChannelOrLibInfo: {
    filterChannelOrLibId: '',
    filterChanenlOrLibImg: '',
    type: ''
  },
  hideOtherPacks: false,
  packDetailInfoId: '',
  isShowPackInfoDetail: false,
  isTvBoxPage: false,
  isRecommendationPage: false,
  isNowEStatus: false,
  isBoxPlan: false,
}

export const GetStartedSlice = createSlice({
  name: 'getStarted',
  initialState,
  reducers: {
    setIsRecommendationPage(state, action: PayloadAction<boolean>) {
      state.isRecommendationPage = action.payload
    },
    setIsTvBoxPage(state, action: PayloadAction<boolean>) {
      state.isTvBoxPage = action.payload
    },
    setIsBoxPlan(state, action: PayloadAction<boolean>) {
      state.isBoxPlan = action.payload
    },
    setSubscribeModalStatus: (state, action: PayloadAction<boolean>) => {
      state.isShowSubscribeModal = action.payload
    },
    setPackInfo: (state, action: PayloadAction<PackInfo>) => {
      state.packInfo = action.payload
    },
    setisShowFitlerPopUp: (state, action: PayloadAction<boolean>) => {
      state.isShowFitlerPopUp = action.payload
    },
    setFilterPlansInfo: (state, action: PayloadAction<IFilterChannelOrLibInfo>) => {
      state.filterChannelOrLibInfo = action.payload
    },
    setHideOtherPacks: (state, action: PayloadAction<boolean>) => {
      state.hideOtherPacks = action.payload
    },
    setPackInfoDetailStatus(state, action: PayloadAction<boolean>) {
      state.isShowPackInfoDetail = action.payload
    },
    setDetailInfoId: (state, action: PayloadAction<any>) => {
      state.packDetailInfoId = action.payload
    },
    setNowEStatus(state, action: PayloadAction<boolean>) {
      state.isNowEStatus = action.payload
    },
  }
})

export const {
  setIsRecommendationPage,
  setIsTvBoxPage,
  setSubscribeModalStatus,
  setPackInfo,
  setisShowFitlerPopUp,
  setFilterPlansInfo,
  setHideOtherPacks,
  setDetailInfoId,
  setPackInfoDetailStatus,
  setNowEStatus,
  setIsBoxPlan
} = GetStartedSlice.actions

export const selectIsShowSubscribeModal = (state: RootState) => state.getStarted.isShowSubscribeModal

export default GetStartedSlice.reducer